import React from "react";

const Use = () => {
 return (
  <div className="bg-Use">
   <h2 className="title1-use">¿Cómo usar esta guía?</h2>
   <span className="text1-use">
    <p>
     En ocasiones nos encontramos con personas que sufren emocionalmente, y nos
     sentimos con el deber de auxiliar de alguna forma, pero lo primero que
     debemos saber es que no siempre podemos ser de ayuda. Incluso algunas veces
     un mal abordaje puede resultar contraproducente para nosotros y/o para
     quién queremos apoyar.
     <br />
     <br />
     Para hacerlo adecuadamente debemos estar tranquilos y receptivos y
     mínimamente preparados.
     <br />
     <br />
     Para ello se puede usar esta guía como una introducción rápida para
     acompañar a una persona que se encuentra atravesando una situación que le
     provoca sufrimiento emocional intenso.
     <br />
     <br />
     Esta guía debe usarse en casos que se consideren oportunos. Para asistir de
     forma recurrente se recomienda tomar una capacitación más extendida.
     <br />
     <br />
    </p>
   </span>
   <h2 className="title2-use">Cuando NO dar Primeros Auxilios Psicológicos</h2>
   <span className="text2-use">
    <ul>
     <li>
      Cuando el conflicto que sufre la persona tiene relación directa con
      nosotros.
     </li>
     <br />
     <li>Cuando el afectado se encuentre en una zona de riesgo.</li>
     <br />
     <li>Cuando hay un enfrentamiento de una o varias posturas sucediendo.</li>
     <br />
     <li>Cuando la persona requiere de servicios médicos de forma urgente.</li>
     <br />
     <li>
      Cuando el tema que provoco la crisis emocional nos afecta profundamente.
     </li>
     <br />
     <li>
      Cuando nos reconocemos ampliamente sesgados para difundir información
      confiable.
     </li>
     <br />
     <li>Cuando no disponemos del tiempo o la paciencia necesaria.</li>
     <br />
     <li>
      Cualquier otro caso en el que no se considere la conveniencia de asistir.
     </li>
    </ul>
    <br />
    <br />
   </span>
  </div>
 );
};

export default Use;
